<template>

  <div id="roster-report" >

    <b-overlay :show="showoverlay" rounded="sm" class="col-md-12">
      <div class="clearfix row py-2 mb-2 no-margin">
        <div class="col-md-2 pr-0 cursor-pointer text-left pl-0 d-flex flex-row align-items-center">

          <b-input-group class="date-range-picker d-flex flex-row align-items-end justify-content-start">
            <b-form-group id="date-group" label-for="date" class="mb-0">
              <b-input-group class="mb-0">
                <b-form-input id="date" name="date" v-model="date" v-validate="{  }" type="text" placeholder="YYYY-MM-DD"
                              autocomplete="off" :state="validateState('date')" aria-describedby="date-feedback" data-vv-as="Date"/>
                <b-input-group-append class="mb-0">
                  <b-form-datepicker v-b-tooltip.hover.top="'Select a date to preview the daily report.'" @input="reset" class="mb-0" id="day_two" button-only right locale="en-US" v-model="date" />
                </b-input-group-append>
                <b-form-invalid-feedback id="date-feedback">
                  {{ veeErrors.first('date') }}
                </b-form-invalid-feedback>
              </b-input-group>
            </b-form-group>
          </b-input-group>
          <b-icon v-if="preview" icon="check-circle-fill" variant="success"></b-icon>


        </div>
        <div class="col-md-10 no-margin p-0">
          <div class="row d-flex justify-content-end no-margin">
            <b-button variant="secondary" class="d-flex justify-content-end m-1" @click="reset()">Reset</b-button>
            <b-button variant="secondary" class="d-flex justify-content-end m-1" @click="previewOrDownloadReport(0, date)">Preview Report</b-button>
            <b-button variant="secondary" class="d-flex justify-content-end m-1" @click="previewOrDownloadReport(1,date)">Download Report (Excel)</b-button>
          </div>
        </div>
      </div>
      <div v-if="preview" class="table-responsive employee-table-wrapper mt-3">
        <table class="employee-list-table table table-hover dataTable table-overflow table-sticky">
          <thead class="table-head">
          <tr class="table-head">
            <th v-for="column in columns" :key="column.name" ><span>{{column.label}}</span></th>
          </tr>
          </thead>

          <tbody>
          <tr v-b-tooltip.hover.top="row.data_source" v-for="row in assignments" :key="row.id" class="hover-bg table-row border-bottom mx-2 cursor-pointer">
            <td @click="showEmployee(row)">
              <div class="d-flex align-items-center">
                <div class="avatar-circle mr-2">
                  <img class="img-fluid img-thumbnail employee-avatar mx-2" :src="$api_url+'/avatar/'+row.company_id+'/'+row.pic" alt="">
                </div>
                <div>
                  <div class="fw-600">{{ row.name }}</div>
                </div>
              </div>
            </td>

            <td @click="showEmployee(row)">{{ row.employee_code || '-' }}</td>
            <td @click="showEmployee(row)">{{ row.department || '-' }}</td>
            <td @click="showEmployee(row)">{{ row.jobposition || '-' }}</td>

            <td @click="showEmployee(row)" v-if="roster == 1">
                  <span v-if="row.shift.name" class="shift-badge py-1 px-3 rounded" :style="{ background: row.shift.color + '22', color: row.shift.color }">
                    {{ row.shift.name }}
                  </span>
                <p class="text-center" v-else>-</p>
            </td>

            <td @click="showEmployee(row)" v-if="roster == 1">
              <span v-if="row.shift && row.shift.start_time">
                {{ row.shift.start_time }}
                -
                {{ row.shift.end_time }}
              </span>
              <span v-else>-</span>
            </td>

            <td :class="{'text-center' : row.check_in == '-'}" @click="showEmployee(row)">{{row.check_in}}</td>
            <td :class="{'text-center' : row.check_out == '-'}" @click="showEmployee(row)">{{row.check_out}}</td>
            <td :class="{'text-center' : row.work_time == '-'}" @click="showEmployee(row)">{{row.work_time}}</td>

            <td @click="showEmployee(row)">
              <span class="shift-badge py-1 px-3 rounded" :style="{ background: row.status_color + '22', color: row.status_color }">
                {{row.status }}
              </span>
            </td>
          </tr>
          </tbody>

        </table>

        <div v-if="assignments.length == 0" class="px-3 py-3 no-result-cell">No Result Found!</div>
      </div>

      <div v-else class="row" id="assignment">
        <div class="col-12">
          <b-badge class="d-inline mb-3" variant="info">Selected Employee: {{employee_ids.length}}</b-badge>
          <div class="card border-0 no-shadow">
            <common-list :checkbox="1" :is_action="0" :appended_column="appended_column" :key="list_key" :company_options="company_options" :employees="custom_list"
                         :all_employee="'no'" :default_column="default_column" :primary_key="'employee_id'" v-on:childToParent="listReturn"></common-list>
          </div>
        </div>
      </div>

    </b-overlay>

    <b-modal id="activity_logModal" size="xl" scrollable  hide-footer>
      <template #modal-title>
        <div class="d-flex flex-row align-items-center">
          <div class="mr-3" :style="{height: '25px',width: '25px', background: shift_color, borderRadius: '50%'}"></div> <span>Attendance Info at {{shift_name}}</span>
        </div>
      </template>
      <div class="row no-margin">
        <div class="col-md-6">
          <div class="card punch-status">
            <div class="card-body">
              <h5 class="card-title">Timesheet <small class="text-muted">{{attendances_date}}</small></h5>
              <div class="punch-det">
                <h6>Punch In at</h6>
                <p>{{check_in}}</p>
              </div>
              <div class="punch-info">
                <div class="punch-hours">
                  <span>{{work_time}}</span>
                </div>
              </div>
              <div class="punch-det">
                <h6>Punch Out at</h6>
                <p>{{check_out}}</p>
              </div>
              <div class="punch-det">
                <h6>Overtime</h6>
                <p>{{over_time}}</p>
              </div>
              <div class="punch-det">
                <h6>Break Time</h6>
                <p>{{break_time}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card recent-activity">
            <div class="card-body">
              <h5 class="card-title">Activity</h5>
              <ul class="res-activity-list" v-if="activity_log">
                <li v-for="(activity, index) in activity_log">
                  <p class="mb-0" v-if="index % 2 == 0">Punch In at</p>
                  <p class="mb-0" v-else>Punch Out at</p>
                  <p class="res-activity-time">
                    <i class="far fa-clock"></i>
                    {{ moment(activity, "YYYY-MM-DD HH:mm:ss").format("hh:mm A") }}
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>


<script>
import moment from "moment";
export default{

  props:['flag'],

  data(){
    const now = new Date();
    let sortOrders = {};
    let columns = [
      {label: 'Employee Name', name: 'name' },
      {label: 'Employee Code', name: 'employee_code' },
      {label: 'Department', name: 'department' },
      {label: 'Job Position', name: 'jobposition' },
      {label: 'Shift Name', name: 'shift_name', type: 'text' },
      {label: 'Shift Time', name: 'shift_time', type: 'text' },
      {label: 'Check In', name: 'check_in' },
      {label: 'Check Out', name: 'check_out' },
      {label: 'Work Time', name: 'work_time' },
      {label: 'Status', name: 'status' },
    ];
    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });

    return {
      roster: 0,
      dates:[],
      pagination: {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', nextbuttonstatus:'true', prebuttonstatus:'disabled'},
      date: '',
      columns: columns,
      sortKey: 'name',
      activity_log: [],
      attendances_date:'',
      check_in:'',
      check_out:'',
      work_time:'',
      over_time:'',
      break_time:'',
      shift_name: '',
      shift_color: '',
      sortOrders: sortOrders,
      checkbox:1,
      is_action:1, /* As this list have actions then is_action will be 1. Otherwise, it will be 0 */
      list_key:0, /* Component Key */
      custom_list:[],  /* Data List */
      default_column:['name','phone','email','jobposition','department','branch','leave_policy','leave_type'], /* Default Column List */
      appended_column:[],
      leave_type_options:[],                /* Appended Column List  and there title and type */
      primary_key:'employee_id',  /* Primary is the unique key of the list this key will be returned if the row is clicked, for employee list is employee_id, For loan list it is loan_id etc here it is employee_id*/
      company_options:[],         /* Company Filterable options */
      employee_ids: [],
      assignments: [],
      showoverlay : false,
      preview : false,
    }
  },
  methods:{
    moment,
    reset(){
      this.preview = false;
      this.employee_ids = [];
      this.list_key++;
      this.getEmployees();
    },
    showEmployee(data){
      if(data.activity_log && Array.isArray(data.activity_log) && data.activity_log.length > 0)
      {
        this.activity_log = data.activity_log.sort((a, b) => {
          return new Date(a.time) - new Date(b.time);
        });
        this.check_in = data.check_in;
        this.check_out = data.check_out;
        this.work_time = data.work_time;
        this.break_time = data.break_time;
        this.over_time = data.over_time;
        this.attendances_date = data.period_date;
        this.shift_name = `${data.shift.name} (${data.shift.start_time} - ${data.shift.end_time})`;
        this.shift_color = data.shift.color;
        this.$bvModal.show('activity_logModal');
      }
    },
    getEmployees() {
      axios.get(this.$api_url + '/leave-attendance/employees/list', { params: {all: this.all,fields:'offday,roster,shift',from: this.date, to: this.date}}).then(response => {
        this.showoverlay = false;
        if(response.data.error == 1)
          this.notice = response.data.notice;
        else
        {
          this.custom_list = response.data.employee_data;
          this.company_options = response.data.options;
          this.list_key = this.list_key + 1;

        }
      }).catch(e => {
        this.serverError(e);
      });
    },

    listReturn:function(data)
    {
      this.employee_ids = data.selected;

    },

    previewOrDownloadReport: function(flg,date)
    {
      if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) {
        return false;
      }
      this.error = null;

      if(!this.checkNet()) return false;
      if(this.employee_ids.length == 0)
      {
        if(flg == 1){
          this.$bvToast.toast('Please select employee(s) to download report', {
            title: `Failed`,
            variant: 'danger',
            solid: true
          });
        } else {
          this.$bvToast.toast('Please select employee(s) to generate report', {
            title: `Failed`,
            variant: 'danger',
            solid: true
          });
        }
        return;
      }
      if(flg == 1)
      {
        this.$bvToast.toast('We are downloading the report, this may take a while.', {
          title: `Hold Tight`,
          variant: 'info',
          solid: true
        });
      }

      let config = {};

      if(flg == 1)
      {
        config = {
          responseType: 'blob'
        }
      }

      const formData = new FormData();
      formData.append('date', date);
      formData.append('download', flg);
      formData.append('employee_ids', JSON.stringify(this.employee_ids));

      this.showoverlay = true;
      axios.post(this.$api_url + '/leave-attendance/daily', formData,config). then(response => {

        if(flg == 0)
        {
          this.assignments = response.data;
          this.preview = true;
        }
        else if(flg == 1)
        {
          this.global_download_file_content(response);
        }
        this.showoverlay = false;
      }).catch(e => this.serverError(e)).finally(()=>{this.loading = false;});

    },
    getCompanyLeaveSettings: function () {
      if (!this.checkNet()) return false;
      axios
        .get(this.$api_url + "/leave-attendance/company/leave/settings")
        .then(
          function (response) {
            if (response.data.length != 0) {
              this.roster = response.data.roster;
              if(this.roster == 0)
              {
                this.columns = this.columns.filter(column => !['shift_name', 'shift_time'].includes(column.name));
              }
            }
          }.bind(this)
        );
    },
  },
  computed:
      {
        filteredData()
        {
          let filtered_list = this.custom_list;
          if (this.search)
          {
            filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});

            if(filtered_list.length == 0)
              this.blankmsg = "Nothing found.";
          }

          this.people = filtered_list.length;

          return filtered_list;
        },
        paginatedData()
        {
          return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
        },
        selectAll: {
          get: function () {
            if(this.employee_ids.length == 0) return false;
            return this.filteredData ? this.employee_ids.length == this.filteredData.length : false;
          },
          set: function (value) {
            let selected = [];
            if (value) {
              this.filteredData.forEach(function (user) {
                selected.push(user.employee_id);
              });
            }
            this.employee_ids = selected;
          }
        },
      },
  created: function(){
    const d = new Date();
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    this.date = `${y}-${m}-${day}`;
    this.getEmployees();
    this.getCompanyLeaveSettings();
  }
}
</script>
